module.exports = __webpack_public_path__ + "assets/img/bg.a11b26d6.png";